var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonServer = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M7.157 19.359c-.165 0-.064-.718.062-1.446.123-.712.313-1.413.572-2.089l3.059-7.979C11.237 6.805 11.826 6 12.774 6h22.16c.949 0 1.536.804 1.925 1.845l3.06 7.98c.258.675.45 1.376.571 2.088.126.728.227 1.446.062 1.446M7.157 34.052c-.165 0-.064-.718.062-1.445.123-.713.313-1.414.572-2.09l3.059-7.979c.387-1.04.976-1.845 1.926-1.845h22.16c.95 0 1.536.804 1.926 1.845l3.058 7.98c.26.675.452 1.376.573 2.089.125.727.227 1.445.061 1.445", fill: fills.light }),
        React.createElement("path", { d: "M9.55 31.623h28.624a2.462 2.462 0 012.462 2.461v5.57a2.462 2.462 0 01-2.462 2.461H9.55a2.462 2.462 0 01-2.462-2.461v-5.57a2.462 2.462 0 012.462-2.461z", fill: fills.base }),
        React.createElement("path", { d: "M35.56 38.02a1.236 1.236 0 100-2.47 1.236 1.236 0 000 2.47z", fill: fills.dark }),
        React.createElement("path", { d: "M9.55 16.93h28.624a2.462 2.462 0 012.462 2.46v5.57a2.462 2.462 0 01-2.462 2.462H9.55a2.462 2.462 0 01-2.462-2.462v-5.57a2.462 2.462 0 012.462-2.46z", fill: fills.base }),
        React.createElement("path", { d: "M35.56 23.328a1.236 1.236 0 100-2.472 1.236 1.236 0 000 2.472z", fill: fills.dark })));
}, {
    name: identiconComponentName,
})({});
